const t=(t,e)=>{const n=e.getAll(t);return 1===n.length?n[0]:n};export{t as getUrlParamValue};
